"use client";

import { QueryClientProvider } from "@tanstack/react-query";
import { loggerLink, createTRPCClient, httpBatchLink } from "@trpc/client";
import { createTRPCContext } from "@trpc/tanstack-react-query";
import dynamic from "next/dynamic";
import { useState } from "react";

import { NODE_ENV } from "@workspace/shared/constants";

import { getUrl } from "~/trpc/shared";

import { env } from "../../env.config";
import { getQueryClient } from "./query-client";
import { transformer } from "./shared";

import type { AppRouter } from "@workspace/api";
const ReactQueryDevtools =
  env.NODE_ENV === NODE_ENV.DEVELOPMENT
    ? dynamic(async () =>
        import("@tanstack/react-query-devtools").then(
          (mod) => mod.ReactQueryDevtools,
        ),
      )
    : () => null;

export const { TRPCProvider, useTRPC, useTRPCClient } =
  createTRPCContext<AppRouter>();

export function TRPCReactProvider(props: { children: React.ReactNode }) {
  const queryClient = getQueryClient();

  const [trpcClient] = useState(() =>
    createTRPCClient<AppRouter>({
      links: [
        loggerLink({
          enabled: (op) =>
            env.NODE_ENV === NODE_ENV.DEVELOPMENT ||
            (op.direction === "down" && op.result instanceof Error),
        }),
        httpBatchLink({
          transformer,
          url: getUrl(),
          headers() {
            const headers = new Headers();
            headers.set("x-trpc-source", "web-client");
            return headers;
          },
        }),
      ],
    }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        {props.children}
        <ReactQueryDevtools />
      </TRPCProvider>
    </QueryClientProvider>
  );
}
